// Safe localStorage wrappers — won't throw in private mode or when quota exceeded
export const storage = {
  get(key) {
    try { return localStorage.getItem(key); } catch { return null; }
  },
  getJSON(key) {
    try { return JSON.parse(localStorage.getItem(key)); } catch { return null; }
  },
  set(key, value) {
    try { localStorage.setItem(key, value); } catch {}
  },
  setJSON(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
  },
  remove(key) {
    try { localStorage.removeItem(key); } catch {}
  },
};
